'use client'

import React from 'react'
import { Text } from '@mantine/core'

export function SectionLabel({ children }: { children: React.ReactNode }) {
    return (
        <Text fz={12} fw={600} tt="uppercase" lts="0.06em" c="var(--gm-fg-tertiery, #6e6d6c)">
            {children}
        </Text>
    )
}
